export default __webpack_public_path__ + "static/media/01.f7b6b146.jpg";